module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vdige6-c0a15eb312f2bda6df3abeccec2aece1.jpg";